import { u as useT, p as jsxRuntimeExports, L as Button } from "./doenetml-NmXDuMHr.js";
import { T as TooltipProvider, a as TooltipAnchor, b as Tooltip } from "./tooltip-provider-Bek2bo6U.js";
function AnswerResponseButton({
  answerId,
  answerComponentIdx,
  activityId,
  docId,
  numResponses = 0,
  flags
}) {
  const t = useT();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(TooltipProvider, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TooltipAnchor, { className: "answer-response-tooltip-anchor", children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Button,
      {
        className: "doenet-button action-button answer-response-button",
        onClick: () => {
          const message = {
            subject: "requestAnswerResponses",
            answerComponentIdx,
            answerId,
            activityId,
            docId
          };
          if (flags.messageParent && window.parent) {
            window.parent.postMessage(message);
          } else {
            window.postMessage(message);
          }
        },
        children: numResponses
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { className: "answer-response-tooltip", children: t(
      "answer-show-responses",
      { count: numResponses, answerId },
      `Show ${numResponses} response${numResponses === 1 ? "" : "s"} to ${answerId}`
    ) })
  ] });
}
export {
  AnswerResponseButton as A
};
